module.exports = __webpack_public_path__ + "static/media/muzykaRWK.a284aae4.jpg";